import { Navigate, useLocation, useParams } from 'react-router-dom';

export const DetailRedirect = () => {
  const { trackingId } = useParams();
  const location = useLocation().search;
  const url = `/details/${trackingId}${location}`;
  return <Navigate to={url} replace />;
};

export const NoMatchRoute = () => {
  let locationHash = useLocation().hash;
  if (locationHash) {
    locationHash = locationHash.replace('#', '');
    return <Navigate to={locationHash} replace />;
  }
  return <Navigate to={'/search'} replace />;
};
